import mutations from './mutations';
import plugin from './plugin';
import state from './state';
import * as actions from './actions';
import * as getters from './getters';

const module = {
  state: { ...state },
  actions,
  getters,
  mutations,
};

export default { module, plugin };



// WEBPACK FOOTER //
// ./src/app/auth/store/index.js